var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H31C32.6569 0 34 1.34315 34 3V31C34 32.6569 32.6569 34 31 34H3C1.34315 34 0 32.6569 0 31V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6053 7H9.89059C8.2944 7 7 8.29449 7 9.89059V24.6044C7 26.2006 8.29449 27.495 9.89059 27.495H24.6044C26.2006 27.495 27.495 26.2005 27.495 24.6044L27.4958 9.89059C27.4958 8.2944 26.2014 7 24.6052 7H24.6053ZM25.7919 24.6055C25.7919 25.2527 25.2525 25.7921 24.6053 25.7921H9.89059C9.24335 25.7921 8.70398 25.2527 8.70398 24.6055V9.89081C8.70398 9.24357 9.24335 8.7042 9.89059 8.7042H24.6044C25.2517 8.7042 25.791 9.24357 25.791 9.89081L25.7919 24.6055Z",
    fill: "#0068FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7966 14.3789H12.0057C11.768 14.3789 11.5742 14.5727 11.5742 14.8104V22.2108C11.5742 22.4485 11.7681 22.6423 12.0057 22.6423H13.7966C14.0343 22.6423 14.2281 22.4484 14.2281 22.2108V14.8104C14.2281 14.5736 14.0343 14.3789 13.7966 14.3789Z",
    fill: "#0068FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.154 11.8555H16.3631C16.1255 11.8555 15.9316 12.0493 15.9316 12.287V22.2114C15.9316 22.4491 16.1255 22.6429 16.3631 22.6429H18.154C18.3917 22.6429 18.5855 22.449 18.5855 22.2114V12.287C18.5644 12.0493 18.3698 11.8555 18.154 11.8555Z",
    fill: "#0068FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49 16.6875H20.6991C20.4614 16.6875 20.2676 16.8813 20.2676 17.119V22.2111C20.2676 22.4488 20.4614 22.6426 20.6991 22.6426H22.49C22.7276 22.6426 22.9215 22.4487 22.9215 22.2111V17.119C22.9215 16.8822 22.7268 16.6875 22.49 16.6875Z",
    fill: "#0068FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H31V-1H3V1ZM33 3V31H35V3H33ZM31 33H3V35H31V33ZM1 31V3H-1V31H1ZM3 33C1.89543 33 1 32.1046 1 31H-1C-1 33.2091 0.790862 35 3 35V33ZM33 31C33 32.1046 32.1046 33 31 33V35C33.2091 35 35 33.2091 35 31H33ZM31 1C32.1046 1 33 1.89543 33 3H35C35 0.790861 33.2091 -1 31 -1V1ZM3 -1C0.790861 -1 -1 0.790862 -1 3H1C1 1.89543 1.89543 1 3 1V-1Z",
    fill: "#E7E6E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.a80963e7b1dfea997e70e4b58b3c0967.svg";
export { ForwardRef as ReactComponent };